export const PROMO_SEARCH_TERMS = Object.freeze({
	DOSE_DUPLA_KODAK: "DOSE DUPLA KODAK",
	VARILUX: "VARILUX",
	DOBRO: "DOBRO",
	CRIZAL: "CRIZAL"
});

export const VOUCHER_PREFIX = Object.freeze({
	KODAK_PREFIX: "21"
});

export const PAR_IDS = Object.freeze({
	PAR_1: "1",
	PAR_2: "2"
});

export const PROMOCAO_TYPES = Object.freeze({
	DOSE_DUPLA_KODAK: "DOSE DUPLA KODAK",
	VARILUX_DOBRO: "VARILUX EM DOBRO",
	CRIZAL_DOBRO: "CRIZAL EM DOBRO"
});

export const PAR_TYPES = Object.freeze({
	PAR_1: "(Par 1)",
	PAR_2: "(Par 2)"
});
